import { AppPhase, DealingSubPhase, GameType } from '../../models/communication/app-enums.model';
import { AppEventType } from '../../models/communication/app-events.model';
import { YEventPayload } from '../../models/y-protocol.model';
import { DragonTigerCardPosition, DragonTigerOutcome } from '../main-games/dragon-tiger/dragon-tiger.model';

type Event = Omit<YEventPayload<AppEventType>, 'triggered'>;

export const configuration = {
    gameType: GameType.OpenDragonTiger,
    decisionTimeInSeconds: 5
};

export const demoEvents: Array<Event | Event[]> = [
    {
        name: AppEventType.GamePhaseChange,
        data: {
            phase: AppPhase.DealingCards,
            subPhase: DealingSubPhase.FaceDown
        }
    },

    {
        name: AppEventType.CardDealt,
        data: {
            card: 0,
            cardPosition: DragonTigerCardPosition.DragonCard,
            dragonHandValue: 0,
            tigerHandValue: 0,
            nextCardPosition: DragonTigerCardPosition.TigerCard
        }
    },

    [
        {
            name: AppEventType.CardDealt,
            data: {
                card: 0,
                cardPosition: DragonTigerCardPosition.TigerCard,
                dragonHandValue: 0,
                tigerHandValue: 0
            }
        },

        {
            name: AppEventType.GamePhaseChange,
            data: {
                phase: AppPhase.DealingCards,
                subPhase: DealingSubPhase.SideSelectionAnimation
            }
        }
    ],

    [
        {
            name: AppEventType.GamePhaseChange,
            data: {
                phase: AppPhase.DealingCards,
                subPhase: DealingSubPhase.RightSide
            }
        },

        {
            name: AppEventType.CardDealt,
            data: {
                card: 402,
                cardPosition: DragonTigerCardPosition.DragonCard,
                dragonHandValue: 2,
                tigerHandValue: 0
            }
        },

        {
            name: AppEventType.GamePhaseChange,
            data: {
                phase: AppPhase.Decision
            }
        }
    ],

    [
        {
            name: AppEventType.GamePhaseChange,
            data: {
                phase: AppPhase.BetsClosed
            }
        },

        {
            name: AppEventType.GamePhaseChange,
            data: {
                phase: AppPhase.DealingCards,
                subPhase: DealingSubPhase.Dealing
            }
        },

        {
            name: AppEventType.CardDealt,
            data: {
                card: 402,
                cardPosition: DragonTigerCardPosition.TigerCard,
                dragonHandValue: 2,
                tigerHandValue: 2,
                outcome: DragonTigerOutcome.DragonWin
            }
        },

        {
            name: AppEventType.GamePhaseChange,
            data: {
                phase: AppPhase.RoundEnd,
                outcome: DragonTigerOutcome.DragonWin
            }
        }
    ]
];
